export default __webpack_public_path__ + "static/media/linker.30eec99e.png";